import styled from 'styled-components';
import { cssVars } from '../../shared/lib/styledTheme';

export const ClientsContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: ${cssVars.bgColor};
  overflow: hidden;
`;

export const ClientsHeader = styled.div`
  position: fixed;
  top: 0;
  left: ${cssVars.sidebarWidth};
  right: 0;
  padding: 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  z-index: 10;
  transition: left 0.3s ease;
`;

export const ClientsTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const SearchForm = styled.form`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SearchInput = styled.input`
  padding: 10px 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  font-family: inherit;
  outline: none;
  min-width: 300px;

  &:focus {
    border-color: ${cssVars.primary};
  }
`;

export const SearchButton = styled.button`
  padding: 10px 20px;
  background-color: ${cssVars.primary};
  color: ${cssVars.white};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.primaryHover};
  }
`;

export const SiteFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SiteFilterLabel = styled.label`
  font-size: 14px;
  color: ${cssVars.textSecondary};
`;

export const SiteFilterSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: ${cssVars.primary};
  }
`;

export const ClientsContent = styled.div`
  flex: 1;
  padding: 24px;
  padding-top: 100px;
  overflow-y: auto;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px;
`;

export const EmptyStateText = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
  margin-bottom: 8px;
`;

export const EmptyStateSubtext = styled.div`
  font-size: 14px;
  color: ${cssVars.textSecondary};
`;

export const ClientsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;
`;

interface ClientCardProps {
  $selected?: boolean;
}

export const ClientCard = styled.div<ClientCardProps>`
  background-color: ${cssVars.bgSecondary};
  border: 1px solid ${(props) => props.$selected ? cssVars.primary : cssVars.borderColor};
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: ${(props) => props.$selected ? `0 0 0 2px ${cssVars.primary}20` : 'none'};

  &:hover {
    border-color: ${cssVars.primary};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ClientCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const ClientCardName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  flex: 1;
`;

export const ClientCardSite = styled.div`
  padding: 4px 8px;
  background-color: ${cssVars.bgTertiary};
  border-radius: 4px;
  font-size: 12px;
  color: ${cssVars.textSecondary};
`;

export const ClientCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ClientInfoRow = styled.div`
  display: flex;
  gap: 8px;
  font-size: 13px;
`;

export const ClientInfoLabel = styled.span`
  color: ${cssVars.textSecondary};
  font-weight: 500;
  min-width: 60px;
`;

export const ClientInfoValue = styled.span`
  color: ${cssVars.textPrimary};
  flex: 1;
`;

export const ClientContactsCount = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${cssVars.borderColor};
  font-size: 12px;
  color: ${cssVars.textSecondary};
`;

export const ClientDetailsPanel = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 400px;
  background-color: ${cssVars.bgSecondary};
  border-left: 1px solid ${cssVars.borderColor};
  display: flex;
  flex-direction: column;
  z-index: 100;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease;
`;

export const ClientDetailsHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClientDetailsTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: ${cssVars.textSecondary};
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: ${cssVars.hover};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ClientDetailsContent = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`;

export const DetailsSection = styled.div`
  margin-bottom: 20px;
`;

export const ToolsSection = styled.div`
  margin-bottom: 20px;
  padding: 10px;
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
`;

export const ToolsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
`;

export const ToolButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 6px 8px;
  background-color: ${cssVars.bgSecondary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 50px;

  &:hover {
    background-color: ${cssVars.hover};
    border-color: ${cssVars.primary};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ToolIcon = styled.span`
  font-size: 18px;
  line-height: 1;
`;

export const ToolLabel = styled.span`
  font-size: 10px;
  color: ${cssVars.textPrimary};
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
`;

export const DetailsSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${cssVars.borderColor};
`;

export const DetailsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 14px;
`;

export const DetailsLabel = styled.span`
  color: ${cssVars.textSecondary};
  font-weight: 500;
  min-width: 100px;
`;

export const DetailsValue = styled.span`
  color: ${cssVars.textPrimary};
  flex: 1;
`;

export const ContactCard = styled.div`
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
`;

export const ContactCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const ContactName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
`;

export const MainContactBadge = styled.span`
  padding: 2px 8px;
  background-color: ${cssVars.primary};
  color: ${cssVars.white};
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
`;

export const ContactEmail = styled.div`
  color: ${cssVars.textPrimary};
`;

export const ContactPhone = styled.div`
  color: ${cssVars.textSecondary};
`;

export const ExternalData = styled.div`
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  padding: 12px;
  font-size: 12px;
  font-family: 'Courier New', monospace;
  color: ${cssVars.textPrimary};
  overflow-x: auto;

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
`;

export const Pagination = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${cssVars.borderColor};
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

export const PaginationInfo = styled.div`
  font-size: 14px;
  color: ${cssVars.textSecondary};
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PaginationButton = styled.button<{ disabled?: boolean }>`
  padding: 8px 16px;
  background-color: ${props => props.disabled ? cssVars.bgTertiary : cssVars.primary};
  color: ${props => props.disabled ? cssVars.textSecondary : cssVars.white};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: ${cssVars.primaryHover};
  }
`;

export const PaginationPageInfo = styled.span`
  font-size: 14px;
  color: ${cssVars.textPrimary};
  font-weight: 500;
`;

